import * as React from "react";
import { Button } from "../button/button.mjs";
import { Container } from "../container/container.mjs";
import "debounce";
import "tabbable";
import { useCurrentBreakPoint } from "../helpers/helper/hooks/use-current-breakpoint.mjs";
import { Separator } from "../separator/separator.mjs";
const ViewAllButton = (props) => {
  const { buttonProps } = props;
  const currentBreak = useCurrentBreakPoint();
  if (!buttonProps) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }), /* @__PURE__ */ React.createElement("p", { className: "text-center" }, /* @__PURE__ */ React.createElement(Button, { ...buttonProps, block: currentBreak === "xs" })));
};
export {
  ViewAllButton
};
